import React, {  useContext, useCallback } from 'react';
import { GameContext } from '../context/GameContext';
import '../styles/SelectedNumbersList.css';


export const SelectedNumbersList = () => {
  const { selectedOption, setSelectedOption, selectedNumbers, againstNumbers, limit, setSelectedNumbers, setAgainstNumbers } = useContext(GameContext);

  const handleOptionSelect = useCallback((option) => {
    if (option === 'Against') {
      setAgainstNumbers((prevAgainstNumbers) => {
        setSelectedNumbers([]);
        return selectedNumbers;
      });
    } else {
      setSelectedNumbers((prevSelectedNumbers) => {
        setAgainstNumbers([]);
        return prevSelectedNumbers;
      });
    }
    setSelectedOption(option);
  }, [selectedNumbers, setAgainstNumbers, setSelectedNumbers, setSelectedOption]);

  return (
    <div className="selected-numbers-list">
      <div className="card1">
        <h3>Selected Numbers</h3>
        {selectedNumbers.length === 0 && (
          <p>No numbers selected yet</p>
        )}
        <div className="numbers-row">
          {selectedNumbers.map((number) => (
            <div key={number} className="number-button1">{number}</div>
          ))}
          <RenderPlaceholderButtons limit={limit} selectedNumbers={selectedNumbers} />
        </div>
      </div>
      {limit[0] === 1 && limit[1] === 24 && (
        <>
          <button
            className={`pay-button ${selectedOption === 'Against' && 'disabled'}`}
            onClick={() => handleOptionSelect('Against')}
            disabled={selectedOption === 'Against'}
          >
            {selectedOption === 'Select Against' ? 'Against' : 'Select Against'}
          </button>
          {selectedOption === 'Against' && (
            <div className="against-numbers-container">
              <h3>Against Numbers:</h3>
              {againstNumbers.length === 0 && (
                <p>Please select your number to perm against</p>
              )}
              <div className="numbers-row">
                {againstNumbers.map((againstNum) => (
                  <div key={againstNum} className="number-button against">{againstNum}</div>
                ))}
              </div>
            </div>
          )}
        </>
      )}
    </div>
  );
};

const RenderPlaceholderButtons = ({ limit, selectedNumbers }) => {
  const getPlaceholderLength = () => {
    if (limit[0] === 1 && limit[1] === 2) {
      return 2 - selectedNumbers.length;
    } else if (limit[0] === 1 && limit[1] === 3) {
      return 3 - selectedNumbers.length;
    } else if (limit[0] === 3 && limit[1] === 24) {
      return 3 - selectedNumbers.length;
    } else if (limit[0] === 4 && limit[1] === 17) {
      return 4 - selectedNumbers.length;
    } else if (limit[0] === 5 && limit[1] === 13) {
      return 5 - selectedNumbers.length;
    } else if (limit[0] === 6 && limit[1] === 12) {
      return 6 - selectedNumbers.length;
    } else if (limit[0] === 1 && limit[1] === 1) {
      return 1 - selectedNumbers.length;
    } else if (limit[0] === 1 && limit[1] === 24) {
      return 1 - selectedNumbers.length;
    } else {
      return 0;
    }
  };

  const placeholderLength = getPlaceholderLength();

  return (
    <div className="numbers-row">
      {Array.from({ length: placeholderLength }, (_, index) => (
        <div key={index} className="number-button placeholder">?</div>
      ))}
    </div>
  );
};

